import { HeadCell } from '@/types/enhancedTable.d';

export const headCellsRestaurantAddOns: HeadCell[] = [
  {
    id: 'thName',
    numeric: false,
    label: 'Thai name',
    disablePadding: false,
    sortAble: true,
    width: 1 / 4,
  },
  {
    id: 'enName',
    label: 'English name',
    numeric: false,
    disablePadding: false,
    sortAble: true,
    width: 1 / 4,
  },
  {
    id: 'price',
    numeric: true,
    label: 'Price',
    disablePadding: false,
    sortAble: true,
    width: 0.4 / 4,
  },
  {
    id: 'actions',
    label: '',
    numeric: false,
    disablePadding: false,
    sortAble: false,
    width: 1 / 4,
  },
];
